module.exports = __webpack_public_path__ + "static/img/2.6.c106eaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/en/upload/picture/2.6.jpg
// module id = yIBG
// module chunks = 7